import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("bs_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setTenant(data.tenant);
    } catch (e) {
      localStorage.removeItem("bs_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bs_token", data.token);
    await refreshMe();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("bs_token", data.token);
    await refreshMe();
    return data;
  };

  const googleSession = async (session_id, plan) => {
    const { data } = await api.post("/auth/google/session", {
      session_id,
      plan,
      origin_url: window.location.origin,
    });
    localStorage.setItem("bs_token", data.token);
    await refreshMe();
    return data;
  };

  const logout = () => {
    localStorage.removeItem("bs_token");
    setUser(false);
    setTenant(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, tenant, loading, login, register, googleSession, logout, refreshMe, setTenant, apiError }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
